'use client';

import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt", "onLoad"];
import React, { useRef, useState } from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import StyledImage, { PlaceholderImage as DefaultPlaceholderImage, PlaceholderImageWrapper, StyledLazyImage as DefaultStyledLazyImage } from "./Image.mjs";
import { useInView as defaultUseInView } from "./useInView.mjs";
export function defineLazyImage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$StyledLazyImage = _ref.StyledLazyImage,
    StyledLazyImage = _ref$StyledLazyImage === void 0 ? DefaultStyledLazyImage : _ref$StyledLazyImage,
    _ref$PlaceholderImage = _ref.PlaceholderImage,
    PlaceholderImage = _ref$PlaceholderImage === void 0 ? DefaultPlaceholderImage : _ref$PlaceholderImage,
    _ref$useInView = _ref.useInView,
    useInView = _ref$useInView === void 0 ? defaultUseInView : _ref$useInView;
  return function LazyImage(_ref2) {
    var _ref2$alt = _ref2.alt,
      alt = _ref2$alt === void 0 ? '' : _ref2$alt,
      _onLoad = _ref2.onLoad,
      props = _objectWithoutProperties(_ref2, _excluded);
    var imageRef = useRef(null);
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      inView = _useState2[0],
      setInView = _useState2[1];
    var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoaded = _useState4[0],
      setIsLoaded = _useState4[1];
    var lazyImage = /*#__PURE__*/React.createElement(StyledLazyImage, Object.assign({}, props, {
      alt: alt,
      ref: imageRef,
      onLoad: function onLoad(event) {
        setIsLoaded(true);
        if (_onLoad) {
          _onLoad(event);
        }
      },
      isLoaded: isLoaded
    }));
    var placeholder = /*#__PURE__*/React.createElement(PlaceholderImageWrapper, props, /*#__PURE__*/React.createElement(PlaceholderImage, {
      alt: alt,
      ref: imageRef,
      src: props.placeholderSrc
    }));
    useInView(imageRef, function () {
      setInView(true);
    });
    if (inView) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !isLoaded && placeholder, lazyImage);
    }
    return placeholder;
  };
}
var LazyImage = defineLazyImage();
export var Image = function Image(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  if ('placeholderSrc' in props && props.placeholderSrc) {
    return /*#__PURE__*/React.createElement(LazyImage, Object.assign({}, props, {
      "data-encore-id": ENCORE_DATA_IDS.Image
    }));
  }
  return /*#__PURE__*/React.createElement(StyledImage, Object.assign({}, props, {
    "data-encore-id": ENCORE_DATA_IDS.Image
  }));
};